import { Flex, Space, Stack, Text } from '@mantine/core';
import { Alert } from 'src/components/Alert';
import { FC } from 'react';
import { InputText } from 'src/components/Form/Text';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { Form } from 'src/form';
import { ActionFooter } from 'src/components/ActionFooter';

import { useAddInteractionDictionary } from './use-add-interaction-dictionary';

export const AddInteractionDictionary: FC = () => {
  const { isPending, handleSubmit, onCancel, initialValues, validate } =
    useAddInteractionDictionary();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  return (
    <>
      <PageTitle title="Add Interaction Dictionary" />

      <Alert type="info" title="Information">
        Adding an <Text fw={500}>interaction dictionary</Text> will create a new
        folder on the server where interaction files need to be placed.
      </Alert>

      <Space h="md" />

      <Form
        initialValues={initialValues}
        validate={validate}
        onSubmit={handleSubmit}
      >
        <Flex
          direction="column"
          justify="space-between"
          style={{ height: '100%' }}
        >
          <Stack gap="lg">
            <InputText
              name="name"
              label="Interaction Dictionary Name"
              placeholder="Enter interaction dictionary name"
              maxLength={50}
            />
          </Stack>

          <ActionFooter
            onCancel={onCancel}
            submitButton="CREATE"
            isLoading={isPending}
          />
        </Flex>
      </Form>
    </>
  );
};
